import {
  Field,
  ComponentRendering,
  TextField,
  RichText as JssRichText,
  withDatasourceCheck,
  LayoutServicePageState,
  useSitecoreContext,
} from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';

import { useRouter } from 'next/router';
import { ComponentProps } from 'lib/component-props';
import compose from 'lib/enhancers/compose';
import withStyles from 'lib/enhancers/withStyles';

import styles from './RichTextFull.module.scss';

const cx = classNames.bind(styles);

type OnlyDisplayFor = {
  queryStringValue: TextField;
  queryString: TextField;
  includeNotSpecified: IncludeNotSpecified;
};

type IncludeNotSpecified = {
  value: boolean;
};

type RichTextFields = {
  content: Field<string>;
};

type RichTextProps = ComponentProps & {
  fields?: RichTextFields;
  rendering: ComponentRendering;
};

const RichTextFull = (props: RichTextProps): JSX.Element | null => {
  const { className, fields: { content } = {}, params: { RenderingIdentifier } = {} } = props;
  const router = useRouter();
  const { sitecoreContext } = useSitecoreContext();

  let shouldDisplay = true;
  let checkQueryParam = '';
  let checkQueryParamValue = '';

  if (sitecoreContext.pageState === LayoutServicePageState.Normal && props.rendering?.params?.onlyDisplayFor) {
    const personalizationParam = JSON.parse(props.rendering?.params?.onlyDisplayFor || '') as OnlyDisplayFor;
    checkQueryParam = personalizationParam.queryString.value?.toString().toLowerCase() || '';
    checkQueryParamValue = personalizationParam.queryStringValue.value?.toString().toLowerCase() || '';
    const includeNotSpecified = personalizationParam.includeNotSpecified.value;

    if (checkQueryParam && checkQueryParamValue) {
      shouldDisplay = false;

      if (router.isReady) {
        if (router.asPath.indexOf('?') > 0) {
          let matchingKeyValue = undefined;
          let queryParamValue = undefined;

          // make our query parameter case insensitive, if we find a passed in param with different case, switch to use that.
          for (const key in router.query) {
            if (key.toLowerCase() === checkQueryParam) {
              matchingKeyValue = router.query[key];
              queryParamValue = (
                Array.isArray(matchingKeyValue) ? matchingKeyValue[0] : matchingKeyValue || ''
              ).toLowerCase();
              break;
            }
          }

          // if match, or param not present and include not specified, then show.
          if (queryParamValue === checkQueryParamValue || (!queryParamValue && includeNotSpecified)) {
            shouldDisplay = true;
          }
        } else {
          // if no query string period, show if includeNotSpecified is true
          shouldDisplay = includeNotSpecified;
        }
      }
    }
  }

  return content && shouldDisplay ? (
    <div className={cx('component', 'rich-text', 'rich-text-full', className)} id={RenderingIdentifier}>
      <JssRichText field={content} />
    </div>
  ) : null;
};

export default compose<RichTextProps>(withDatasourceCheck(), withStyles())(RichTextFull);
